import {
  faCircle as faCircleRegular,
  faSquare as faSquareRegular,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faCheck,
  faCircle as faCircleSolid,
  faSquare as faSquareSolid,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { CheckboxColor } from './VoxelCheckbox';

export interface VoxelTableCheckboxProps {
  disabled?: boolean;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  color?: CheckboxColor;
  shape?: 'circle' | 'square';
  className?: string;
}

export const VoxelTableCheckbox: React.FC<VoxelTableCheckboxProps> = ({
  disabled,
  checked = false,
  onChange,
  color = 'outlined',
  shape = 'square',
  className,
}) => {
  let boxIcon = faSquareRegular;
  let boxColor = 'text-voxel-gray-200';

  let checkIcon = faCheck;
  let checkColor = 'text-voxel-gray-200';

  let hoverColor = 'group-hover:bg-voxel-gray-100/75';

  // Shape
  if (shape === 'square' && !checked) {
    boxIcon = faSquareRegular;
  }
  if (shape === 'square' && checked && color === 'outlined') {
    boxIcon = faSquareRegular;
  }
  if (shape === 'square' && checked && !(color === 'outlined')) {
    boxIcon = faSquareSolid;
  }
  if (shape === 'circle' && !checked) {
    boxIcon = faCircleRegular;
  }
  if (shape === 'circle' && checked && color === 'outlined') {
    boxIcon = faCircleRegular;
  }
  if (shape === 'circle' && checked && color !== 'outlined') {
    boxIcon = faCircleSolid;
  }

  // COLORING

  // Unchecked states
  if (!checked) {
    boxColor = 'text-gray-400/70';
  }

  if (disabled) {
    boxColor = 'text-voxel-gray-300';
    checkColor = 'text-voxel-gray-300';
  }

  // Checked states
  if (color === 'primary') {
    hoverColor = 'group-hover:bg-primary-100';
    if (checked) {
      boxColor = 'text-primary-600';
      checkColor = 'text-white';
    }
  }
  if (color === 'outlined') {
    hoverColor = 'group-hover:bg-voxel-gray-200/50';
    if (checked) {
      boxColor = 'text-slate-900';
      checkColor = 'text-slate-900';
    }
  }
  if (color === 'slate') {
    hoverColor = 'group-hover:bg-voxel-blue-100/50';
    if (checked) {
      boxColor = 'text-slate-600';
      checkColor = 'text-white';
    }
  }
  if (color === 'emerald') {
    hoverColor = 'group-hover:bg-emerald-600/10';
    if (checked) {
      boxColor = 'text-emerald-600/70';
      checkColor = 'text-white';
    }
  }
  if (color === 'indigo') {
    hoverColor = 'group-hover:bg-indigo-500/10';
    if (checked) {
      boxColor = 'text-indigo-500';
      checkColor = 'text-white';
    }
  }

  return (
    <div
      onClick={() => !!onChange && onChange(!checked)}
      className={`
        fa-layers fa-fw fa-1x
        rounded-full
        ${!disabled && hoverColor}
        ${!disabled && 'cursor-pointer'}
        ${className}
      `}
    >
      <FontAwesomeIcon icon={boxIcon} size={'lg'} className={`${boxColor}`} />
      {!!checked && <FontAwesomeIcon icon={checkIcon} size={'sm'} className={`${checkColor}`} />}
    </div>
  );
};

export default VoxelTableCheckbox;
